export function mensagemDeErroPadrao(nomeCampo: string) {
    return `O campo "${nomeCampo}" não pode ser vazio!`
}
